import { render } from "./Snackbar.vue?vue&type=template&id=2fdafa3d&scoped=true"
import script from "./Snackbar.vue?vue&type=script&lang=js"
export * from "./Snackbar.vue?vue&type=script&lang=js"

import "./Snackbar.vue?vue&type=style&index=0&id=2fdafa3d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2fdafa3d"

export default script